import { Component, inject, input } from '@angular/core';
import {ChipModule} from "primeng/chip";

import {ButtonModule} from "primeng/button";
import {RippleModule} from "primeng/ripple";
import {MessageService} from "primeng/api";
import {DataService} from "../../../service/data.service";
import { BetaReaderStatus, ProjectMatchStatus } from 'src/app/api/enums';
import {Utils} from "../../../api/utils";
import { ProjectMatchType } from 'src/app/api/db/entities/ProjectMatchType';

@Component({
    selector: 'project-detail',
    imports: [
    ChipModule,
    ButtonModule,
    RippleModule
],
    templateUrl: './project-detail.component.html',
    styleUrl: './project-detail.component.scss'
})
export class ProjectDetailComponent {
    private messageService = inject(MessageService);
    private dataService = inject(DataService);

    readonly projectMatch = input.required<ProjectMatchType>();

    protected readonly Array = Array;

    async setInterested() {
        const projectMatch = this.projectMatch();
        //console.log('BetaReaderProject Save: ',projectMatch.betaReaderProject);
        /*let betaReaderProject = await this.dataService.getBRPByProjectId(this.projectMatch().project);
        if (!betaReaderProject) {
            await this.dataService.saveBetaReaderProject(projectMatch.betaReaderProject);
        }*/
        //await this.dataService.setBetaReaderStatus(projectMatch.betaReaderProject, BetaReaderStatus.PENDING_RESPONSE);
        await this.dataService.setProjectMatchTypeStatus(this.projectMatch(), ProjectMatchStatus.BETA_READER_REQUEST_ACCEPTANCE);
        projectMatch.projectMatchStatus = ProjectMatchStatus.BETA_READER_REQUEST_ACCEPTANCE;
        this.messageService.add({ severity: 'info', summary: 'Writer Notified', detail: 'We\'ve notified the writer of your interest in being a beta reader for this project.' });
    }

    async setNotInterested() {
        const projectMatch = this.projectMatch();
        /*console.log('BetaReaderProject Save: ',projectMatch.betaReaderProject);
        if (!projectMatch.betaReaderProject.id) {
            await this.dataService.saveBetaReaderProject(projectMatch.betaReaderProject);
        }*/

        //await this.dataService.setBetaReaderStatus(projectMatch.betaReaderProject, BetaReaderStatus.NOT_INTERESTED);
        await this.dataService.setProjectMatchTypeStatus(this.projectMatch(), ProjectMatchStatus.BETA_READER_REJECTED);

        projectMatch.projectMatchStatus = ProjectMatchStatus.BETA_READER_REJECTED;
    }

    protected readonly BetaReaderStatus = BetaReaderStatus;
    protected readonly ProjectMatchStatus = ProjectMatchStatus;
    protected readonly Utils = Utils;
}
